import { type Option } from '~/components/Select/Select';

interface JSONCarrierFormField {
  default_value?: boolean | string;
  display_type: string;
  field_type: string;
  help_url: Maybe<string>;
  hidden_by_key?: string;
  hidden_by_value?: boolean | string | undefined;
  is_required: boolean;
  key: string;
  label: string;
  max_length: Maybe<number>;
  min_length: Maybe<number>;
  options?: Option[];
  placeholder_text: Maybe<string>;
  rank: number;
}

interface CarrierFormField {
  agreementLabels?: string[];
  agreementUrls?: string[];
  defaultValue?: boolean | string;
  disabled?: boolean;
  displayType: string;
  fieldType: string;
  helpUrl: Maybe<string>;
  hiddenByKey?: string; // if the specified key is present and has a non-null value then hide this parameter
  hiddenByValue?: boolean | string | undefined; // the fields with hiddenByKey will be hidden depending on this value
  hiddenOnProd?: boolean; // if true, this field will be hidden in production environment
  isRequired: boolean;
  key: string;
  label: string;
  maxLength: Maybe<number>;
  minLength: Maybe<number>;
  options?: Option[];
  placeholderText: Maybe<string>;
  rank: number;
  tooltip?: string;
}

const fromJSON = (jsonCarrierFormField: JSONCarrierFormField): Maybe<CarrierFormField> => {
  if (!jsonCarrierFormField) return null;

  const serialized: CarrierFormField = {
    defaultValue: jsonCarrierFormField.default_value,
    displayType: jsonCarrierFormField.display_type,
    fieldType: jsonCarrierFormField.field_type,
    helpUrl: jsonCarrierFormField.help_url,
    hiddenByKey: jsonCarrierFormField.hidden_by_key,
    hiddenByValue: jsonCarrierFormField.hidden_by_value,
    isRequired: jsonCarrierFormField.is_required,
    key: jsonCarrierFormField.key,
    label: jsonCarrierFormField.label,
    maxLength: jsonCarrierFormField.max_length,
    minLength: jsonCarrierFormField.min_length,
    options: jsonCarrierFormField.options,
    placeholderText: jsonCarrierFormField.placeholder_text,
    rank: jsonCarrierFormField.rank,
  };

  // Return null if invalid form field
  if (!serialized.rank || !serialized.label || !serialized.key) return null;

  return serialized;
};

export { CarrierFormField, JSONCarrierFormField, fromJSON };
